import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

export interface AlertData {
    name?: string;
    message?: string;
}

@Injectable({ providedIn: 'root' })
export class FuseAlertService {
    private readonly _onDismiss: ReplaySubject<string> = new ReplaySubject<string>(1);
    private readonly _onShow: ReplaySubject<AlertData> = new ReplaySubject<AlertData>(1);

    // Accessors
    get onDismiss(): Observable<string> {
        return this._onDismiss.asObservable();
    }

    get onShow(): Observable<AlertData> {
        return this._onShow.asObservable();
    }

    // Dismiss an alert by name
    dismiss(name: string): void {
        if (!name) return;
        this._onDismiss.next(name);
    }

    // Show an alert with optional message
    show(name: string, message?: string): void {
        if (!name) return;
        this._onShow.next({ name, message });
    }
}
